import { Toaster } from 'sonner'

/**
 * Toaster brutal — wrapper de sonner con estilo del DS del proyecto.
 *
 * Posición top-right para no chocar con el bottom sticky de mobile
 * (JoinCallToActionFixed, MobileTabBar). Estilo brutal: border 2px ink,
 * sombra dura 4px, bg verde para success / rojo para error / amarillo
 * para info / crema para el aviso normal (`toast(...)` sin tipo, el de los
 * «Deshacer»), font-display. Con `unstyled` cada tipo necesita SU fondo: el
 * normal no tenía y salía transparente sobre la cabecera (nov-2026).
 *
 * Uso desde cualquier componente, SIEMPRE por `notify` (ESLint prohíbe sonner directo):
 * ```tsx
 * import { notify } from '@/shared/lib/notify'
 * notify.success(t('toasts.joinedPlayer'))
 * ```
 *
 * Montado una sola vez en `App.tsx`.
 */
export function BrutalToaster() {
  return (
    <Toaster
      position="top-right"
      duration={3500}
      gap={10}
      offset={16}
      // closeButton fuera por defecto — auto-dismiss a los 3.5s es suficiente.
      // visibleToasts cap natural de sonner = 3.
      toastOptions={{
        unstyled: true,
        classNames: {
          toast:
            'brutal-sm flex items-center gap-3 rounded-lg px-4 py-3 font-display text-sm font-bold w-[min(20rem,calc(100vw-2rem))]',
          title: 'leading-tight',
          // Botón de acción (p.ej. «Deshacer» de runUndoable): pastilla brutal pequeña.
          actionButton:
            'brutal-sm brutal-press ml-auto shrink-0 rounded-md bg-background px-3 py-1 font-brutal text-[11px] font-bold uppercase tracking-widest text-foreground',
          default: 'bg-background text-foreground',
          success: 'bg-green text-background',
          error: 'bg-red text-background',
          info: 'bg-yellow text-foreground',
          warning: 'bg-yellow text-foreground',
        },
      }}
    />
  )
}
